import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import UserAvatar from '../../../../User/Avatar';
import s from './SubscriptionPromotion.scss';
export var SubscriptionPromotion = function (_a) {
    var deviation = _a.deviation;
    var t = useTranslation().t;
    if (!deviation.author) {
        return null;
    }
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['content'] },
            React.createElement(UserAvatar, { className: s['avatar'], user: deviation.author, withTooltip: true, size: 48, relatedItemBiData: {
                    typeid: deviation.typeId,
                    itemid: deviation.deviationId,
                } }),
            React.createElement("div", { className: s['text'] }, t('sidebar.tierPromotion.body')),
            React.createElement(BiLink, { className: s['btn-subscribe'], href: Url.userSubscriptionsPath({
                    username: deviation.author.username,
                }), biData: {
                    evid: BiEventType.VIEW_SUBSCRIPTION_TAB,
                    typeid: deviation.typeId,
                    itemid: deviation.deviationId,
                    referral_info: ReferralType.SIDEBAR_PROMOTION,
                } }, t('sidebar.tierPromotion.button.subscribe')))));
};
SubscriptionPromotion.displayName = 'SubscriptionPromotion';
export default SubscriptionPromotion;
//# sourceMappingURL=SubscriptionPromotion.js.map